// Ce que l'absence fait à chacun des élèves, tel que le backend l'a décidé
// (`GET live-sessions/{id}/absence-impact`, règle `TutorAbsenceRelationRule`) :
// l'app ne rejuge rien, elle met des mots dessus. Dans l'app tuteur on dit
// « masteur », et rien ne s'accorde au genre de qui lit : les phrases passent
// par « ton absence ».

export const IMPACT_TITLE = "Ce que ton absence change"

const FINAL = "C'est définitif, même si tu annules ton absence."

// La phrase de fin du bloc, qui n'existe que si un élève change de masteur.
export const TUTOR_CHANGE_CONSEQUENCE =
    "Un élève qui débute avec toi a besoin de son masteur dès le début : " +
    `ton absence lui en donne un nouveau. ${FINAL}`

export const isTutorChange = (student) => student?.outcome === "tutor_change"

const tutorChanges = (students) => (students ?? []).filter(isTutorChange)

// Sans changement de masteur, l'écran de confirmation reste celui d'avant.
export const hasTutorChange = (students) => tutorChanges(students).length > 0

export const impactStatusLabel = (student) =>
    isTutorChange(student) ? "Change de masteur" : "Remplacé"

// Pourquoi l'élève change de masteur, selon la raison que renvoie le backend.
const REASON_LINES = {
    relation_not_started: () => "Vous n'avez pas encore eu cours ensemble.",
    nascent_relation_long_absence: (student) =>
        `Vous venez de commencer, et ton absence touche ${student.touched_occurrences} de vos séances.`,
}

// Sous le prénom : pourquoi il change de masteur, et, à moins de 24 h, la
// séance qu'il garde avant de partir ; pour un élève remplacé, qui assure.
export const impactDetails = (student) => {
    if (!isTutorChange(student)) return ["Un autre masteur assure cette séance."]

    return [
        REASON_LINES[student.reason]?.(student),
        student.short_notice
            ? "Cette séance est assurée par un remplaçant, puis changement de masteur."
            : null,
    ].filter(Boolean)
}

// Tous ses élèves changent de masteur, aucun ne garde la séance : elle se vide,
// personne n'est remplacé — donc aucun crédit d'absence n'est décompté.
export const emptiesSession = (students) =>
    (students ?? []).length > 0 &&
    students.every((student) => isTutorChange(student) && !student.short_notice)

// Les élèves que l'aperçu a MONTRÉS changeant de masteur : la déclaration les
// renvoie pour que le backend n'applique jamais un changement qu'il n'a pas montré.
export const tutorChangeIds = (students) =>
    tutorChanges(students).map((student) => student.id)

const joinNames = (names) =>
    names.length > 1
        ? `${names.slice(0, -1).join(", ")} et ${names[names.length - 1]}`
        : names[0] ?? ""

// Le dialogue du refus arrive après la confirmation, loin du bloc d'impact :
// il nomme donc lui-même les élèves qui changent de masteur.
export const tutorChangeNotice = (students) => {
    const names = tutorChanges(students).map((student) => student.firstname)

    return (
        `Avec ton absence, ${joinNames(names)} ${names.length > 1 ? "changent" : "change"} de masteur. ` +
        `${FINAL} Confirme à nouveau pour déclarer ton absence.`
    )
}
